<div class="h-100 d-flex flex-column">
  <div class="align-items-center justify-content-center d-flex flex-grow-1">
    <div class="w-100">
      <div class="mb-4 d-flex justify-content-center">
        <ng-content select="[full-screen-image]" />
      </div>

      <div class="me-4 ms-4 text-center">
        <h3>
          <ng-content select="[full-screen-title]" />
        </h3>

        <p class="mt-1 step-description">
          <ng-content select="[full-screen-description]" />
        </p>
      </div>
      <div #buttons class="me-4 ms-4 d-flex flex-column gap-3" [class.mt-4]="buttons.children.length">
        <ng-content select="[full-screen-buttons]" />
      </div>
    </div>
  </div>
  @if (withBanner()) {
    <ui-powered-by-carepay />
  }
</div>
